export const iconFontAwesomeUsersPeoplePersonHiking = (
	<i className="fa-solid fa-person-hiking"></i>
);
